"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var disclaimers_1 = require("../models/disclaimers");
var GlobalDisclaimerStore = /** @class */ (function () {
    function GlobalDisclaimerStore() {
        this.lastSuperscript = 0;
        this.values = [];
        this.subscribers = [];
    }
    GlobalDisclaimerStore.prototype.subscribe = function (subscriber) {
        if (!this.subscribers) {
            this.subscribers = [];
        }
        this.subscribers.push(subscriber);
    };
    GlobalDisclaimerStore.prototype.publish = function () {
        if (this.subscribers && this.subscribers.length > 0) {
            this.subscribers.forEach(function (subscriber) {
                if (subscriber && typeof subscriber === 'function') {
                    subscriber();
                }
            });
        }
    };
    GlobalDisclaimerStore.prototype.add = function (appKey, responseContext, queryStore) {
        var optionsParams = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            optionsParams[_i - 3] = arguments[_i];
        }
        var response = new Set();
        if (!this.values) {
            this.values = [];
        }
        var hasChange = false;
        var _loop_1 = function (options) {
            // Add text logic in here too
            var disclaimerType = options.disclaimerType, _a = options.textQuery, textQuery = _a === void 0 ? {} : _a;
            if (textQuery) {
                var text = disclaimers_1.GlobalDisclaimerStoreValue.getText(queryStore, disclaimerType, textQuery, responseContext);
                // SETUP NEW COMPOSITE KEY WITH TYPE AND TEXT
                if (text && text.length > 0) {
                    var compositeKey_1 = disclaimerType + "_" + text;
                    var existing = this_1.values.find(function (value) { return value.key === compositeKey_1; });
                    if (existing) {
                        existing.addApp(appKey, options);
                        response.add(existing);
                    }
                    else {
                        var value = new disclaimers_1.GlobalDisclaimerStoreValue(queryStore, ++this_1.lastSuperscript, compositeKey_1, responseContext, appKey, options);
                        this_1.values.push(value);
                        response.add(value);
                    }
                    if (this_1.values.length > 0) {
                        hasChange = true;
                    }
                }
            }
        };
        var this_1 = this;
        for (var _a = 0, optionsParams_1 = optionsParams; _a < optionsParams_1.length; _a++) {
            var options = optionsParams_1[_a];
            _loop_1(options);
        }
        // Order here is important otherwise the reorder would not fire
        hasChange = this.reorder() || hasChange;
        if (hasChange) {
            this.publish();
        }
        return Array.from(response);
    };
    GlobalDisclaimerStore.prototype.get = function (level, appKey) {
        return this.values.filter(function (value) { return value.matches(level, appKey); }).sort(function (a, b) {
            return a.superscript - b.superscript;
        });
    };
    GlobalDisclaimerStore.prototype.clear = function () {
        this.values = [];
        this.publish();
    };
    GlobalDisclaimerStore.prototype.reorder = function () {
        var hasChange = false;
        var ordersDefined = this.values.some(function (v) { return v.order !== disclaimers_1.GlobalDisclaimerStoreValue.maxOrder; });
        if (ordersDefined) {
            var currentOrder = this.values.map(function (v) { return v.superscript; });
            this.values = this.values.sort(function (a, b) {
                if (a.order === b.order) {
                    return (a.superscript < b.superscript) ? -1 : (a.superscript > b.superscript) ? 1 : 0;
                }
                return (a.order < b.order) ? -1 : 1;
            });
            var newOrder = this.values.map(function (v) { return v.superscript; });
            for (var i = 0; i < currentOrder.length; i++) {
                var oldValue = currentOrder[i];
                var newValue = newOrder[i];
                if (oldValue !== newValue) {
                    hasChange = true;
                    break;
                }
            }
            if (hasChange) {
                this.values.forEach(function (value, index) {
                    value.superscript = index + 1;
                });
            }
        }
        return hasChange;
    };
    return GlobalDisclaimerStore;
}());
exports.GlobalDisclaimerStore = GlobalDisclaimerStore;
//# sourceMappingURL=GlobalDisclaimerStore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/stores/GlobalDisclaimerStore.js
// module id = 885
// module chunks = 1